import { Truck } from 'lucide-react';

export const LoadingScreen = () => {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center bg-[hsl(222,47%,3%)]"
      data-testid="loading-screen"
    >
      <div className="relative">
        <div className="w-20 h-20 rounded-full border-4 border-slate-800 border-t-amber-500 animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <Truck className="text-amber-500" size={32} />
        </div>
      </div>
      <p className="mt-6 text-slate-400 font-semibold uppercase tracking-wider text-sm">
        Chargement...
      </p>
    </div>
  );
};

export default LoadingScreen;
